import axios from '../../../../shared/axios/axios';

import * as actionTypes from '../constants/actionTypes';

import { validateObj } from '../../../../shared/utils';

const getSignatureBytesStart = () => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_START,
  };
};

const getSignatureBytesSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_SUCCESS,
    data,
  };
};

const getSignatureBytesFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_FAIL,
    error,
  };
};

export const getSignatureBytes = (signatureId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getSignatureBytesStart());

      const url = `/signature/get-signature-bytes`;

      axios
        .get(url, { responseType: 'blob', params: validateObj({ signatureId }) })
        .then((response) => {
          new Response(response.data).arrayBuffer().then((result) => {
            dispatch(getSignatureBytesSuccess(result));
            resolve(result);
          });
        })
        .catch((err) => {
          dispatch(getSignatureBytesFail(err));
          reject(err);
        });
    });
  };
};

const getSignatureStyleLookupStart = () => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_START,
  };
};

const getSignatureStyleLookupSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_SUCCESS,
    data,
  };
};

const getSignatureStyleLookupFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_FAIL,
    error,
  };
};

export const getSignatureStyleLookup = (searchString) => {
  return (dispatch) => {
    dispatch(getSignatureStyleLookupStart());

    const url = `/signature/get-signature-style-lookup`;

    axios
      .get(url, { params: validateObj({ searchString }) })
      .then((response) => {
        dispatch(getSignatureStyleLookupSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSignatureStyleLookupFail(err));
      });
  };
};

const getGeneratedSignatureStart = () => {
  return {
    type: actionTypes.SIGNATURE_GET_GENERATED_SIGNATURE_START,
  };
};

const getGeneratedSignatureSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_GET_GENERATED_SIGNATURE_SUCCESS,
    data,
  };
};

const getGeneratedSignatureFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_GET_GENERATED_SIGNATURE_FAIL,
    error,
  };
};

export const getGeneratedSignature = (signatureStyle, signatureName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getGeneratedSignatureStart());

      const url = `/signature/generate-signature`;

      axios
        .get(url, { responseType: 'blob', params: validateObj({ signatureStyle, signatureName }) })
        .then((response) => {
          new Response(response.data).arrayBuffer().then((result) => {
            dispatch(getGeneratedSignatureSuccess(result));
            resolve(result);
          });
        })
        .catch((err) => {
          dispatch(getGeneratedSignatureFail(err));
          reject(err);
        });
    });
  };
};

const saveSignatureStart = () => {
  return {
    type: actionTypes.SIGNATURE_SAVE_SIGNATURE_START,
  };
};

const saveSignatureSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_SAVE_SIGNATURE_SUCCESS,
    data,
  };
};

const saveSignatureFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_SAVE_SIGNATURE_FAIL,
    error,
  };
};

export const saveSignature = ({
  signatureId,
  signatureBytes,
  signatureName,
  signatureSource,
  truckingCompanyId,
  policyId,
  agentId,
  insuranceAgencyId,
  certificateHolderId,
}) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(saveSignatureStart());

      const url = `/signature/save-signature`;

      axios
        .post(
          url,
          validateObj({
            signatureId,
            signatureBytes,
            signatureName,
            signatureSource,
            truckingCompanyId,
            policyId,
            agentId,
            insuranceAgencyId,
            certificateHolderId,
          }),
        )
        .then((response) => {
          dispatch(saveSignatureSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveSignatureFail(err));
          reject(err);
        });
    });
  };
};

const getSignatureNameStart = () => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_NAME_START,
  };
};

const getSignatureNameSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_NAME_SUCCESS,
    data,
  };
};

const getSignatureNameFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_NAME_FAIL,
    error,
  };
};

export const getSignatureName = (signatureId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getSignatureNameStart());

      const url = `/signature/get-signature-parameters`;

      axios
        .get(url, { params: validateObj({ signatureId }) })
        .then((response) => {
          dispatch(getSignatureNameSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSignatureNameFail(err));
          reject(err);
        });
    });
  };
};

const getOriginalSignatureBytesStart = () => {
  return {
    type: actionTypes.SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_START,
  };
};

const getOriginalSignatureBytesSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_SUCCESS,
    data,
  };
};

const getOriginalSignatureBytesFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_FAIL,
    error,
  };
};

export const getOriginalSignatureBytes = (signatureId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getOriginalSignatureBytesStart());

      const url = `/signature/get-signature-bytes`;

      axios
        .get(url, { responseType: 'blob', params: validateObj({ signatureId }) })
        .then((response) => {
          new Response(response.data).arrayBuffer().then((result) => {
            dispatch(getOriginalSignatureBytesSuccess(result));
            resolve(result);
          });
        })
        .catch((err) => {
          dispatch(getOriginalSignatureBytesFail(err));
          reject(err);
        });
    });
  };
};
